import { render } from "./NumberQuestion.vue?vue&type=template&id=47fe493a"
import script from "./NumberQuestion.vue?vue&type=script&lang=ts"
export * from "./NumberQuestion.vue?vue&type=script&lang=ts"
script.render = render

export default script